<div class="dvb-schulung-support">
    <h2 transloco="SCHULUNG.SUPPORT.TITLE"></h2>
</div>
